import {
    type DimensionValue,
    type StyleProp,
    type ViewStyle,
    StyleSheet
} from "react-native";

const FIT_CONTENT = "fit-content" as DimensionValue;

const SIZE_STYLE_KEYS: Array<keyof ViewStyle> = [
    "flexBasis",
    "alignSelf",
    "flexGrow",
    "width",
    "flex"
];

export const getHugStyle = ({
    style
}: {
    style?: StyleProp<ViewStyle> | Array<StyleProp<ViewStyle>>;
}): ViewStyle => {
    const flatStyle = StyleSheet.flatten(style as StyleProp<ViewStyle>) ?? {};

    if(SIZE_STYLE_KEYS.some((key) => flatStyle[key] !== undefined)) {
        return {};
    }

    return {
        width: FIT_CONTENT
    };
};
